module.exports = __webpack_public_path__ + "static/4-this-is-weird-without-you-3dbd41702c36b8d06564551c687c95e4.jpg";